/**
 * Converts a Date, date string, or epoch milliseconds to UTC epoch milliseconds.
 * Empty, nullish, or unparseable values return null so callers can fail closed.
 *
 * @param value - Instant as a Date, string, or number the Date constructor can parse
 * @returns Epoch milliseconds, or null when `value` is empty or invalid
 *
 * @example
 * toEpochMs('2026-01-01T00:00:00.000Z'); // 1767225600000
 * toEpochMs(null); // null
 */
export function toEpochMs(value: unknown): number | null {
  if (
    value == null ||
    value === '' ||
    (typeof value !== 'string' &&
      typeof value !== 'number' &&
      !(value instanceof Date))
  ) {
    return null;
  }

  const ms = new Date(value).getTime();
  return Number.isNaN(ms) ? null : ms;
}
